module.exports = __webpack_public_path__ + "img/appl.d05f33c6.svg";